<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{'partitions.cursors.titleMjp.shortLabel' | translate}}
                <app-tooltip text="{{'partitions.cursors.titleMjp.summary' | translate}}"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="cursors-list">
        <ng-container *ngFor="let year of simulation.years;">
            <section class="cursor-item" *ngIf="year.isEstimated">
                <header>
                    <h3>{{year.year}}</h3>
                </header>
                <div class="content">
                    <form #indiceForm="ngForm" class="param-form">
                        <mat-form-field>
                            <mat-label>{{'partitions.cursors.originalAmount.shortLabel' | translate}}</mat-label>
                            <input matInput type="text" name="indice" disabled
                                [ngModel]="year.originalAmount | formatAmount: 'rounded': false ">
                            <span matSuffix> €</span>
                        </mat-form-field>
                        <mat-form-field class="param-form-files">
                            <mat-label>{{'partitions.cursors.fileAmount.shortLabel' | translate}}</mat-label>
                            <mat-select value="total">
                                <mat-option value="total" *ngIf="!year.fileAmount || year.fileAmount === 0">
                                    {{'partitions.cursors.noFiles.shortLabel' | translate}}
                                </mat-option>
                                <mat-option value="total" *ngIf="year.fileAmount && year.fileAmount !== 0">
                                    {{year.fileAmount | formatAmount: 'rounded': false}} €
                                </mat-option>
                                <mat-option class="param-form-file" value ="option.name" disabled *ngFor="let option of year.files;">
                                    {{option.name}} : {{option.amount | formatAmount: 'rounded': false}} €
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </form>

                    <app-hapy-cursor
                        [cursor]="cursor"
                        [mode]="IndiceModeType.amount"
                        [value]="year.amount"
                        [isDisabled]="!year.isEditable"
                        [isNotEditable]="!year.isEditable"
                        [allowInput]="true"
                        (valueChanged)="applyValue($event, year, true)"></app-hapy-cursor>
                </div>
            </section>
        </ng-container>
    </mat-card-content>
</mat-card>
